// extracted by mini-css-extract-plugin
export default {"root":"subsPopup_root__WZHgc","button":"subsPopup_button__qCh7P"};